import axios from "@/plugins/axios";
import { Site } from "@/shared/Site";
import { Groupe } from "@/shared/Groupe";
import { SiteFromServer } from "@/shared/Site";

export default function setAxiosHeaders(token: string) {
  axios.defaults.headers.common["Authorization"] = "Basic " + token;
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  // axios.defaults.headers["X-Client-Csi"] = true;
}

export function orderTotalSites(sites: any, groupes: Groupe[]) {
  // console.log("la");
  const sitesOrdred = new Array();
  for (const site of sites) {
    const new_site = new Site(site.libelle);
    new_site.restaurantId = site.restaurantId;
    sitesOrdred.push(site);
  }

  if (groupes !== undefined && groupes.length > 0) {
    // console.log(groupes)
    for (const groupe of groupes) {
      for (const site of sitesOrdred) {
        if (site.groupe === undefined) {
          site.groupe = new Array();
        }
        if (groupe.raisonsSociales.indexOf(site.libelle) !== -1) {
          site.groupe.push(groupe.raisonSociale);
        }
      }
    }
  } else {
    for (const site of sites) {
      site.groupe = ["TOUS"];
    }
  }
  // console.log(sitesOrdred);
  return sitesOrdred;
}

export function orderSites(sites: any, groupes: Groupe[], client: string) {
  if (client === "TOTAL") {
    return orderTotalSites(sites, groupes);
  } else {
    // console.log("je suis la ", client);
    if (groupes !== undefined && groupes.length > 0) {
      // console.log(groupes)
      for (const groupe of groupes) {
        for (const site of sites) {
          if (site.groupe === undefined) {
            site.groupe = new Array();
          }
          if (groupe.restaurantIds.indexOf(site.restaurantId) !== -1) {
            site.groupe.push(groupe.raisonSociale);
          }
        }
      }
    }
    return sites;
  }
}

export function orderSitesWithPos(sites: [], caisses: any) {
  const mescaisses = caisses["site+caisses"];
  sites.map((site: Site) => (site.caisses = mescaisses[site.restaurantId]));
  return sites;
}

export function orderSitesWithVendeurs(sites: [], vendeurs: any) {
  const mesvendeurs = vendeurs["site+vendeurs"];
  sites.map((site: Site) => (site.vendeurs = mesvendeurs[site.restaurantId]));
  return sites;
}
